import FullPageLoader from "components/shared/FullPageLoader"
import { useEffect } from "react"
import { useLocation, Redirect } from "react-router-dom"
import qs from "query-string"
import isEmpty from "lodash/isEmpty"
import Helmet from "react-helmet"
import { AUTH_KEY, REDIRECT_TO_HONK_TEXT } from "shared/constants"
import PropTypes from "prop-types"
import {
  useForceAuthEffect,
  useVerificationRedirectEffect
} from "components/Login/hooks"

const host = process.env.REACT_APP_COREAPP_BASE

const PreRedirect = () => {
  useForceAuthEffect()
  useVerificationRedirectEffect()
  // expects oaTag param and r param (for the redirect post-consume)
  const { pathname, search } = useLocation()
  const rawQuery = qs.parse(search)
  const { oaTag, r, title, message, copy } = rawQuery

  useEffect(() => {
    const url = new URL(`/consume`, host)
    url.search = qs.stringify({ oaTag, r })

    const timer = setTimeout(() => {
      if (r && oaTag) {
        window.location.assign(url)
      }
    }, 2000)
    return () => {
      clearTimeout(timer)
    }
  }, [r, oaTag])

  const needsAuthParam = isEmpty(oaTag)

  if (needsAuthParam)
    return (
      <Redirect
        to={{
          pathname,
          search: qs.stringify({ oaTag: localStorage.getItem(AUTH_KEY), r })
        }}
      />
    )

  return (
    <>
      <Helmet title={title || REDIRECT_TO_HONK_TEXT.title} />
      <FullPageLoader
        message={message || REDIRECT_TO_HONK_TEXT.message}
        copy={copy || REDIRECT_TO_HONK_TEXT.copy}
      />
    </>
  )
}

PreRedirect.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  copy: PropTypes.string,
  redirectUrl: PropTypes.string
}

PreRedirect.defaultProps = {
  title: REDIRECT_TO_HONK_TEXT.title,
  message: REDIRECT_TO_HONK_TEXT.message,
  copy: REDIRECT_TO_HONK_TEXT.copy,
  redirectUrl: null
}

export default PreRedirect
